import { NavLink } from "react-router-dom";

const icons = {
  home: (
    <path d="M4 11.5 12 4l8 7.5M6 10v9a1 1 0 0 0 1 1h3v-6h4v6h3a1 1 0 0 0 1-1v-9" />
  ),
  info: <path d="M12 8h.01M11 12h1v5h1M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" />,
  report: (
    <path d="M12 9v4m0 4h.01M10.3 3.9 2.6 17.5A1.5 1.5 0 0 0 4 19.8h16a1.5 1.5 0 0 0 1.4-2.3L13.7 3.9a1.5 1.5 0 0 0-2.6 0Z" />
  ),
  ball: <><circle cx="12" cy="12" r="8" /><path d="M12 4v2M12 18v2M4 12h2M18 12h2" strokeLinecap="round" /></>,
};

function Icon({ name }: { name: keyof typeof icons }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
      {icons[name]}
    </svg>
  );
}

export function BottomNav({ clubId }: { clubId: string }) {
  const base = `/club/${clubId}`;
  const items: { to: string; label: string; icon: keyof typeof icons; end?: boolean }[] = [
    { to: base, label: "Dashboard", icon: "home", end: true },
    { to: `${base}/info`, label: "Club-Infos", icon: "info" },
    { to: `${base}/ballflug`, label: "Ballflug", icon: "ball" },
    { to: `${base}/melden`, label: "Melden", icon: "report" },
  ];

  return (
    <nav
      aria-label="Hauptnavigation"
      className="fixed inset-x-0 bottom-0 z-20 border-t border-chalk-200 bg-chalk-50/90 backdrop-blur-md pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="mx-auto flex max-w-md">
        {items.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex min-h-16 flex-col items-center justify-center gap-1 text-xs font-medium transition-colors ${
                  isActive ? "text-turf-700" : "text-ink-400"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-full transition-colors ${
                      isActive ? "bg-turf-100" : ""
                    }`}
                  >
                    <Icon name={item.icon} />
                  </span>
                  {item.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
